/**
 * Klient `POST /v1/duediligence/cases/:id/claims` (krok G4 - tvrzeni maklere).
 * Krok S3: jedno API, jeden typovany klient (`lib/api.ts`).
 */

import { apiClient } from './api.js';
import { unwrap } from './api-error.js';

export type BrokerClaimInput =
  | { readonly kind: 'BUILDING_INTENT'; readonly buildingRef: string; readonly intent: 'DEMOLISH' | 'KEEP' | 'UNKNOWN' }
  | { readonly kind: 'CORRIDOR_SIDE'; readonly side: 'WEST' | 'EAST' | 'NORTH' | 'SOUTH' }
  | { readonly kind: 'FREE_TEXT'; readonly text: string };

export interface BrokerClaimQuestion {
  readonly questionKey: string;
  readonly text: string;
}

export interface BrokerClaimResult {
  readonly kind: string;
  readonly fact: { readonly id: string; readonly factKey: string } | null;
  readonly demolitionFact: { readonly id: string; readonly factKey: string } | null;
  readonly questions: readonly BrokerClaimQuestion[];
}

export async function recordBrokerClaim(
  caseId: string,
  input: BrokerClaimInput,
): Promise<BrokerClaimResult> {
  return unwrap(
    apiClient.POST('/v1/duediligence/cases/{id}/claims', {
      params: { path: { id: caseId } },
      body: input,
    }),
  ) as Promise<BrokerClaimResult>;
}
